export const DIMENSION_WEIGHTS = {
  D1: 0.18,
  D2: 0.14,
  D3: 0.16,
  D4: 0.08,
  D5: 0.1,
  D6: 0.07,
  D7: 0.11,
  D8: 0.16,
};

export const DIMENSION_META = {
  D1: { title: 'Revenue Quality & Velocity', color: '#0097A7' },
  D2: { title: 'Receivables Profile (DSO)', color: '#0097A7' },
  D3: { title: 'Buyer Concentration & Quality', color: '#FF9800' },
  D4: { title: 'Sector & Product Stability', color: '#4CAF50' },
  D5: { title: 'Business Model Risk Flags', color: '#4CAF50' },
  D6: { title: 'Geographic / FX Exposure', color: '#0097A7' },
  D7: { title: 'Returns / Disputes Behavior', color: '#4CAF50' },
  D8: { title: 'Tax Compliance Posture', color: '#4CAF50' },
};

export const TIER_BANDS = [
  { tier: 'PRIME', min: 820, max: 900, summary: 'Top-decile profile.' },
  { tier: 'STRONG', min: 720, max: 819, summary: 'Above-average. Competitive pricing, standard product mix.' },
  { tier: 'STANDARD', min: 620, max: 719, summary: 'Average risk.' },
  { tier: 'WATCH', min: 520, max: 619, summary: 'Enhanced due diligence.' },
  { tier: 'RESTRICTED', min: 300, max: 519, summary: 'High risk. Secured only.' },
];

export const MICI_MIN = 300;
export const MICI_MAX = 900;

export const GAP_MOCK_DEFAULTS = {
  prior12MRevenue: 15557000,
  ftaValidatedRatio: 1,
  sectorBenchmarkDso: 45,
  collectionRate: 91.2,
  distinctCategories: 12,
  avgLinesPerInvoice: 4.3,
  unitPriceCv: 0.07,
  sectorDisputeRate: 0.035,
  avgDisputeResolutionDays: 14,
  litigatedDisputes: 0,
  reverseChargeAnomalies: 0,
  filingConsistency: 100,
};

export const EXCEL_GOLDEN_INPUTS = {
  D1: {
    ttmRevenue: 18420000,
    prior12MRevenue: 15557000,
    monthlyMean: 1535000,
    monthlyStdev: 218000,
    ftaValidatedCount: 1247,
    totalInvoiceCount: 1247,
  },
  D2: {
    weightedDso: 52,
    sectorBenchmarkDso: 45,
    collectionRate: 91.2,
    distinctPaymentMeans: 4,
  },
  D3: {
    hhi: 0.084,
    top5Share: 0.418,
    activeBuyers: 47,
    recurringBuyers: 31,
  },
  D4: {
    distinctCategories: 12,
    avgLinesPerInvoice: 4.3,
    unitPriceCv: 0.07,
  },
  D5: {
    standardB2bShare: 0.87,
    freeZoneShare: 0.08,
    exportShare: 0.05,
    riskyChannelShare: 0.001,
  },
  D6: {
    aedShare: 0.88,
    distinctCurrencies: 3,
    mainlandConcentration: 0.78,
    exportRevenueShare: 0.05,
  },
  D7: {
    creditNoteRatio: 0.018,
    sectorDisputeRate: 0.035,
    avgDisputeResolutionDays: 14,
    litigatedDisputes: 0,
  },
  D8: {
    standardRatedShare: 0.92,
    zeroRatedShare: 0.06,
    exemptShare: 0.02,
    reverseChargeAnomalies: 0,
    filingConsistency: 100,
  },
};

export const EXCEL_GOLDEN_SCORES = {
  D1: 77.5517137,
  D2: 65.21266667,
  D3: 58.77414894,
  D4: 78.58333333,
  D5: 85.6525,
  D6: 70.89,
  D7: 91.96428571,
  D8: 93.4,
  composite: 77.36723373,
  mici: 764,
  tier: 'STRONG',
};
